import { Box, Typography } from '@mui/material'
import React from 'react'

interface IErrorProps {
  message?: string
}

const InError: React.FC<IErrorProps> = ({ message = '' }) => {
  return (
    <Box sx={{ display: 'fles', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', width: '100%' }}>
      <Typography>{message}</Typography>
    </Box>
  )
}

export default InError
